type RouteString = {
  [key: string]: string;
};

export const extensionsRoutes: RouteString = {
  Login: '/login',
  Home: '/',
  Profile: '/profile',
  Reports: '/reports',
  Logout: '/logout',
};
